<div class="message-footer__wrapper">
  <ng-container [ngSwitch]="mode">
    <message-reply *ngSwitchCase="'reply'" [message]="message" [color]="'blue'"></message-reply>
    <message-reply *ngSwitchCase="'edit'" [message]="message" [color]="'blue'"></message-reply>
  </ng-container>

  <button
    tuiIconButton
    type="button"
    appearance="icon"
    iconStart="@tui.x"
    size="s"
    [tuiHint]="'common.buttons.delete' | translate"
    (click)="deleteFooterMessage()"
  ></button>
</div>
